module.exports = __webpack_public_path__ + "assets/img/tab2_08.2559f112.jpg";